// Banking section index — import + reconcile entry points.

import { AppShell } from '@/components/AppShell';
import { OPERATIONS, Tile, TileGroup } from '@/pages/Gateway';

export function BankingSectionPage() {
  // Banking-only subset of OPERATIONS (filter out Tally / e-Invoice queue which belong in Admin).
  const tiles = OPERATIONS.filter((t) => t.href?.startsWith('/banking/'));

  return (
    <AppShell
      pageHeader={
        <div>
          <h1 className="font-display text-display-md font-semibold text-obsidian" style={{ letterSpacing: 'var(--tracking-display)' }}>
            Banking
          </h1>
          <p className="mt-1 text-body-sm text-slate">Bank statement import + reconciliation.</p>
        </div>
      }
    >
      <TileGroup label="Banking" hint="HDFC · ICICI · SBI · Axis · Kotak · Yes · BoB · PNB" kind="emerald">
        <div className="orz-stagger grid grid-cols-1 gap-3 sm:grid-cols-2">
          {tiles.map((t) => <Tile key={t.title} {...t} />)}
        </div>
      </TileGroup>
    </AppShell>
  );
}
